import { ListingApplicationPayload } from 'api/ats';
import { postJson } from 'utils/http/postJson';

export async function userDashboardApiCreateListingApplication(
  payload: ListingApplicationPayload,
) {
  return postJson('/data/listing-applications', payload);
}
